import { useState } from "react";

export type TimeZone = {
  olsonName: string;
  description: string;
};

export type GetTimezonesQuery = { data: { timeZones: TimeZone[] } };

export type GetTimezonesQueryVariables = {
  locale: string;
};

export const useGetTimezonesQuery = (): [
  (variables: GetTimezonesQueryVariables) => Promise<void>,
  {
    data: GetTimezonesQuery | undefined;
    loading: boolean;
    error: Error | undefined;
  },
] => {
  const [data, setData] = useState<GetTimezonesQuery | undefined>();
  const [error, setError] = useState<Error | undefined>();
  const [loading, setLoading] = useState(false);

  const getTimezones = async (variables: GetTimezonesQueryVariables) => {
    setLoading(true);

    try {
      const response = await fetch("https://atlas.shopifycloud.com/graphql", {
        headers: {
          "content-type": "application/json; charset=utf-8",
        },
        body: JSON.stringify({
          operationName: "timeZones",
          query: `query timeZones($locale: SupportedLocale!) {
            timeZones(locale: $locale) {
              olsonName,
              description
            }
          }`,
          variables: {
            locale: variables.locale.toUpperCase(),
          },
        }),
        method: "POST",
      });

      if (!response.ok) {
        throw new Error(await response.text());
      }

      setData((await response.json()) as GetTimezonesQuery);
    } catch (e) {
      setError(e as Error);
    }

    setLoading(false);
  };

  return [getTimezones, { data, loading, error }];
};
